import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useLazyGetKycDataQuery } from "store/api/kyc/kyc"

const useFetchKycData = () => {
  const { user, userType } = useSelector((state) => state?.user)
  const navigate = useNavigate()
  const [kycData, setKycData] = useState(null)
  const [getResult, { isFetching: isLoading }] = useLazyGetKycDataQuery()

  const getKycData = async () => {
    try {
      const { success, data } = await getResult().unwrap()
      if (success) {
        setKycData(data)

        // dispatch(
        //   setLoginUserData({
        //     user: {
        //       ...user,
        //       phone: data.phone,
        //       email: data.email,
        //       kyc_status: data.kyc_status,
        //     },
        //   })
        // )
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (userType && userType === "ADMIN") {
      navigate("/platform-manager/system-configuration")
    }
    if (userType && userType !== "ADMIN") {
      getKycData()
    }
  }, [userType])

  return { kycData, isLoading, user, userType, navigate }
}

export default useFetchKycData
